export default {
  0: { color: '#52bdbe' /*green blue*/, label: 'Grundstellung' },
  1: { color: '#FBAF5D' /*orange*/, label: 'Handbetrieb' },
  2: { color: '#1da6c9' /*bright blue*/, label: 'Automatik' },
  3: { color: '#FB785D' /*red*/, label: 'Error' }
};
